import React, { useState } from 'react';
import Navbar from '../Components/NavBarV2';
import Footer from '../Components/footer';
import img_qr from '../images/eventopri.jpg';

const QrEvents = () => {
    return (
        <div>
            <Navbar />

            <div style={{ textAlign: 'center' }}>
                <img 
                    src={img_qr} 
                    alt="Código QR de eventos" 
                    style={{ width: '90%', height: 'auto', borderRadius: '20px', marginTop:'5em' }} 
                />
            </div>
        
        </div >

    );

};


export default QrEvents;